var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ui-stage',[_c('AdminList',{attrs:{"apiPrefix":`/api/v3/${_setup.modulePath}`,"module":_setup.modulePath},scopedSlots:_vm._u([{key:"toolbar",fn:function(){return [(false)?_c('div',{style:({ marginBottom: '8px' })},[_vm._v("下载当日日志")]):_vm._e()]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }